import { mapYields } from '@/helpers/yields';
import Vue from 'vue';

const GET_YIELDS = 'getYields';
const GET_OVERVIEW = 'getOverview';
const GET_ALL_YEARS = 'getAllYears';

const RESET = 'reset';

const defaultState = () => ({
  fetchError: null,
  yields: [],
  overview: {
    firstYieldDate: null,
    isFetching: false,
    yesterday: 0,
    sevenDays: 0,
    month: 0,
    year: 0,
    forever: 0,
  },
});

export default {
  namespaced: true,

  state: defaultState(),

  getters: {
    yield(state) {
      return year => state.yields.find(({ date: { year: y } }) => y === year);
    },
  },

  /* eslint-disable no-param-reassign */
  mutations: {
    [GET_YIELDS](state) {
      state.yields = [];
    },

    [`${GET_YIELDS}+pending`]: (state, { meta: { year, period } }) => {
      let yearYield = state.yields.find(({ date: { year: y } }) => y === year);

      if (!yearYield) {
        yearYield = { date: { year }, [period]: [], isFetching: false };
        state.yields = [...state.yields, yearYield];
      }

      yearYield[period] = [];
      yearYield.isFetching = true;
    },

    [`${GET_YIELDS}+success`]: (state, { payload, meta: { period, year, month } }) => {
      const yearYield = state.yields.find(({ date: { year: y } }) => y === year);

      let yields = yearYield[period];

      switch (period) {
        case 'month':
          yields = yields.filter(y => !(y.month === month && y.year === year));
          break;
        default:
          yields = yields.filter(y => !(y.year === year));
          break;
      }

      Vue.set(yearYield, period, [...yields, ...mapYields(payload)]);

      yearYield.isFetching = false;
    },

    [`${GET_YIELDS}+rejected`]: (state, { payload: error, meta: { year } }) => {
      const yearYield = state.yields.find(({ date: { year: y } }) => y === year);

      yearYield.isFetching = false;
    },

    [`${GET_OVERVIEW}+pending`]: (state) => {
      state.overview.isFetching = true;
    },

    [`${GET_OVERVIEW}+success`]: (state, { payload }) => {
      state.overview.isFetching = false;
      state.overview.firstYieldDate = payload.firstYieldDate;
      Object.assign(state.overview, payload.production);
    },

    [`${GET_OVERVIEW}+rejected`]: (state, { payload: error }) => {
      state.overview.isFetching = false;
      state.fetchError = error.message;
    },

    [RESET]: (state) => {
      Object.assign(state, defaultState());
    },
  },
  /* eslint-disable no-param-reassign */

  actions: {
    [GET_YIELDS]({ commit, getters }, { period = 'year', year, month }) {
      const yyield = getters.yield(year);
      const today = new Date();

      if (
        yyield
        && period === 'month'
        && !(year === today.getFullYear() && month === today.getMonth())
        && yyield.month
        && yyield.month.filter(y => y.year === year && y.month === month).length > 0
      ) {
        return Promise.resolve(yyield.month.filter(y => y.year === year && y.month === month));
      }

      if (
        yyield
        && period === 'year'
        && !(year === today.getFullYear())
        && yyield.year
        && yyield.year.filter(y => y.year === year).length > 0
      ) {
        return Promise.resolve(yyield.year.filter(y => y.year === year));
      }

      return this.$bind({ commit }, GET_YIELDS, { period, year, month }).with($api => this.$q(() => $api.get(`/yields/${period}`, {
        params: { year, month: month >= 0 ? month + 1 : undefined },
      })));
    },

    [GET_OVERVIEW](store) {
      return this.$bind(store, GET_OVERVIEW).with($api => $api.get('/yields/overview'));
    },

    async [GET_ALL_YEARS]({ dispatch }) {
      const { firstYieldDate } = await dispatch(GET_OVERVIEW);

      const startYear = new Date(firstYieldDate).getFullYear();

      const currentYear = new Date().getFullYear();

      const reqs = [];

      for (let year = currentYear; year >= startYear; year -= 1) {
        reqs.push(dispatch(GET_YIELDS, { year, period: 'year' }));
      }

      await Promise.all(reqs);
    },
  },
};
